<template>
    <div ref="buttonContainer" class="dropdown" id="measureBtn">
        <button class="dropbtn-measure" ref="measureButton" id="dropbtnMeasure"
                :disabled="(drawingStore.showSelectBorder || drawingStore.showDrawDirectionLine) && measureButtonText === 'Measure'"
                :class="{ 
                    'disabled-measure': (drawingStore.showSelectBorder || drawingStore.showDrawDirectionLine) && measureButtonText === 'Measure',
                    'visible': isDropdownVisible, 
                    'active-measure': ['cancel', 'clear', 'stop'].includes(measureStore.measureBtnState)
                }"
                :style="{ backgroundColor: ['cancel', 'clear', 'stop'].includes(measureStore.measureBtnState) ? '#ff0000' : '' }"
                @click="handleMeasureButtonClick">
            {{ measureButtonText }}
        </button>

        <ul v-show="isDropdownVisible" class="dropdown-menu">
            <li class="dropdown-btn">
                <button class="dropdown-item" id="distanceBtn" @click="startDistanceMeasurement">
                    {{ $t('Distance') }}
                </button>
            </li>
            <li class="dropdown-btn">
                <button class="dropdown-item" id="areaBtn" @click="startAreaMeasurement">
                    {{ $t('Area') }}
                </button>
            </li>
        </ul>
    </div>
</template>

<script>
import { useMeasure } from '@/stores/measuring'
import { useDrawingStore } from '@/stores/drawing'

export default {
    name: 'MapDistanceControl',
    data() {
        return {
            isDropdownVisible: false,
            outsideClickHandler: null
        }
    },
    setup() {
        const measureStore = useMeasure()
        const drawingStore = useDrawingStore()

        return {
            measureStore,
            drawingStore
        }
    },
    computed: {
        measureButtonText() {
            const stateTextMap = {
                cancel: this.$t('Cancel'),
                stop: this.$t('Stop'),
                clear: this.$t('Clear'),
                default: this.$t('Measure')
            }
            return stateTextMap[this.measureStore.measureBtnState] || stateTextMap.default
        }
    },
    mounted() {
        this.outsideClickHandler = this.handleOutsideClickMeasure.bind(this)
    },
    beforeUnmount() {
        if (this.outsideClickHandler) {
            document.removeEventListener('click', this.outsideClickHandler)
            this.outsideClickHandler = null
        }
    },
    watch: {
        '$route'(to, from) {
            if (to.name !== from.name) {
                this.measureStore.clearMeasuring(this.$refs.buttonContainer)
            }
            if (to.name === 'home') {
                this.measureStore.removeMapDistanceControl()
            }
        }
    },
    methods: {
        handleMeasureButtonClick() {
            if (this.measureStore.measureBtnState === 'cancel') {
                this.measureStore.clearMeasuring(this.$refs.buttonContainer)
            } else if (this.measureStore.measureBtnState === 'clear') {
                this.measureStore.clearMeasuring(this.$refs.buttonContainer)
            } else if (this.measureStore.measureBtnState === 'stop') {
                this.measureStore.stopMeasuring()
            } else {
                this.toggleDropdown()
            }
        },
        toggleDropdown() {
            this.isDropdownVisible = !this.isDropdownVisible
            if (this.isDropdownVisible) {
                if (!this.outsideClickHandler) {
                    this.outsideClickHandler = this.handleOutsideClickMeasure.bind(this)
                }
                document.addEventListener('click', this.outsideClickHandler)
            }
        },
        startDistanceMeasurement() {
            this.isDropdownVisible = false
            this.measureStore.startMeasuring('distance', this.$refs.buttonContainer)
        },
        startAreaMeasurement() {
            this.isDropdownVisible = false
            this.measureStore.startMeasuring('area', this.$refs.buttonContainer)
        },
        handleOutsideClickMeasure(event) {
            // Check if the click was outside the dropdown
            if (this.$refs.buttonContainer && !this.$refs.buttonContainer.contains(event.target)) {
                this.isDropdownVisible = false
                document.removeEventListener('click', this.outsideClickHandler)
                this.outsideClickHandler = null
            }
        }
    }
}
</script>

<style src="@/styles/mapDistanceControl.scss" lang="css"></style>